<template>
  <b-nav-item :to="userRol.base_path">
    <feather-icon
      size="21"
      icon="GridIcon"
    />
  </b-nav-item>
</template>

<script>
// import { computed } from '@vue/composition-api'
import { BNavItem } from 'bootstrap-vue'
// import store from '@/store/index'
import { rolesActions } from '@core/mixins/account-data/roles'

export default {
  components: {
    BNavItem,
  },
  mixins: [rolesActions],
  // setup() {
  //   const rolBasePath = computed(() => store.state.cuenta.rolSelected.base_path)

  //   return { rolBasePath }
  // },
}
</script>
